import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function AllpaySuccess() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const tid = searchParams.get("tid");

    if (window.opener && !window.opener.closed) {
      // Opened as popup — notify opener and close
      try { window.opener.postMessage({ type: "allpay_success", tid }, "*"); } catch {}
      window.close();
    } else if (window !== window.top) {
      // Inside an iframe (Allpay redirected us) — notify top frame
      try { window.top.postMessage({ type: "allpay_success", tid }, "*"); } catch {}
      try { window.top.location.replace(`/topup?paid=1&tid=${tid || ""}`); } catch {}
    } else {
      // Full-page redirect
      window.location.replace(`/topup?paid=1&tid=${tid || ""}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", gap: 12,
      background: "#0b0f19", color: "#fff",
    }}>
      <div style={{
        width: 48, height: 48, borderRadius: "50%",
        border: "3px solid #8B5CF6", borderTopColor: "transparent",
        animation: "spin 0.8s linear infinite",
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{ fontSize: 14, opacity: 0.6 }}>Completing payment...</p>
    </div>
  );
}
